import { LabelsAction } from './actions'
import fetchReducerFor, { fetchInitialState, FetchState } from '../redux/fetch/reducerFor'
import { Labels, LABELS_PREFIX, LABELS_RESOURCE_NAME } from './model'

export type LabelsFetcherState = FetchState<Labels>

const labelsFetchReducer = (origin?: string) => {
  const labelsFetchReducerForOrigin = fetchReducerFor<Labels>(LABELS_RESOURCE_NAME, LABELS_PREFIX, origin)
  return function reducer(state: LabelsFetcherState = fetchInitialState, action: LabelsAction): LabelsFetcherState {
    return {
      ...state,
      ...labelsFetchReducerForOrigin(state, action)
    }
  }
}

export default labelsFetchReducer
